import React from "react";
import { Box, Typography, Button } from "@mui/material";
import ResponsiveDialog from "./ResponsiveDialog.js";
import { finalPulse } from "../ProgressButton.js";
import { Verified, WorkspacePremiumOutlined, CheckCircle } from "@mui/icons-material";

const SimpleUpgradeConsumerDialogContent = ({
  handleContinue,
  handleManageTrial,
  continueText,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        padding: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: 70,
          height: 70,
          borderRadius: "50%",
          backgroundColor: "rgba(129, 129, 129, 0.10)",
          margin: "auto",
          mb: 2,
        }}
      >
        <WorkspacePremiumOutlined sx={{ fontSize: 50, color: "black" }} />
      </Box>
      <Typography
        variant={"h2"}
        sx={{
          mt: 1,
          fontSize: "26px",
          textWrap: "pretty",
          lineHeight: 1.4,
          mb: 3,
        }}
      >
        You've started a 7 day trial of Stanza+
      </Typography>

      {/* Feature list with checkmarks */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          mb: 3,
          textAlign: "left",
          maxWidth: "280px",
          margin: "0 auto 24px auto",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <CheckCircle sx={{ fontSize: 20, color: "black" }} />
          <Typography variant="body1" sx={{ fontSize: "16px" }}>
            Unlimited calendars
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <CheckCircle sx={{ fontSize: 20, color: "black" }} />
          <Typography variant="body1" sx={{ fontSize: "16px" }}>
            Organize with groups
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <CheckCircle sx={{ fontSize: 20, color: "black" }} />
          <Typography variant="body1" sx={{ fontSize: "16px" }}>
            Near real-time updates
          </Typography>
        </Box>
      </Box>

      <Box sx={{ mt: 2 }}>
        <Button
          variant="contained"
          onClick={handleContinue}
          sx={{
            width: "100%",
            animation: `${finalPulse} 3s infinite`,
            mb: 2,
          }}
        >
          {continueText || "Continue"}
        </Button>
        <Button
          variant="outlined"
          onClick={handleManageTrial}
          sx={{
            width: "100%",
          }}
        >
          Manage Trial
        </Button>
      </Box>
    </Box>
  );
};

const SimpleUpgradeConsumerDialog = ({
  open,
  handleClose,
  handleContinue,
  handleManageTrial,
}) => {
  return (
    <ResponsiveDialog
      open={open}
      handleClose={handleClose}
      hideCloseButton={false}
      bottomProps={{
        hideRectangle: true,
        bubbleStyle: true,
        sx: { ".MuiDialogTitle-root": { p: "0px" } },
      }}
      centerProps={{
        sx: {
          height: "auto",
          ".MuiPaper-root": { maxWidth: "393px" },
          ".MuiDialogContent-root": { pt: "20px" },
        },
      }}
    >
      <SimpleUpgradeConsumerDialogContent
        handleContinue={handleContinue}
        handleManageTrial={handleManageTrial}
      />
    </ResponsiveDialog>
  );
};

export default SimpleUpgradeConsumerDialog;
